var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "237px",
    height: "327px",
    viewBox: "0 0 237 327",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wave_3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 237,
    height: 327
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.8138001%",
    y1: "-49.5488178%",
    x2: "137.065295%",
    y2: "61.413258%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.6001668%",
    y1: "-49.5488178%",
    x2: "143.39658%",
    y2: "61.413258%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.8254075%",
    y1: "-49.5488178%",
    x2: "145.210064%",
    y2: "61.413258%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.2439738%",
    y1: "-49.5488178%",
    x2: "148.580072%",
    y2: "61.413258%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.5020205%",
    y1: "-49.5488178%",
    x2: "150.657687%",
    y2: "61.413258%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.7066592%",
    y1: "-49.5488178%",
    x2: "152.305298%",
    y2: "61.413258%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.7628763%",
    y1: "-49.5488178%",
    x2: "152.757919%",
    y2: "61.413258%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.9200441%",
    y1: "-49.5488178%",
    x2: "154.023327%",
    y2: "61.413258%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.9955343%",
    y1: "-49.5488178%",
    x2: "154.631121%",
    y2: "61.413258%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.0167412%",
    y1: "-49.5488178%",
    x2: "154.801865%",
    y2: "61.413258%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.1592753%",
    y1: "-49.5488178%",
    x2: "155.949452%",
    y2: "61.413258%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCE7",
    offset: "99.9180507%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wave_3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lines",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(180.825467, 554.000000) scale(-1, -1) translate(-180.825467, -554.000000) translate(-300.174533, 237.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.360304,544.502358 C328.080755,546.270283 320.480888,499.954175 344.541648,459.64194 C369.866097,417.211731 415.450106,397.764552 420.514996,355.334343 C425.579886,312.904134 403.163949,270.473926 383.794544,270.473926 C357.203872,270.473926 329.346978,256.330523 297.691416,300.528657 C288.862047,312.854633 270.634774,349.180195 262.237187,392.460776 C249.481262,458.209921 256.339122,542.815757 291.360304,544.502358 Z",
    id: "Stroke-1",
    stroke: "url(#linearGradient-3)",
    transform: "translate(338.761429, 406.435737) rotate(-90.000000) translate(-338.761429, -406.435737) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.967805,565.567375 C353.563005,555.433398 342.13046,498.2512 366.39091,453.584033 C392.374891,405.743298 435.694669,387.497923 450.457254,349.907143 C457.47476,332.036058 456.556392,291.964062 441.297735,282.756148 C427.038854,274.149209 433.578097,250.683087 415.9472,241.577093 C405.949447,236.412578 397.682858,236.352832 389.402276,236.164808 C361.02316,235.523417 334.053396,222.386325 298.050039,263.802607 C281.326063,283.042577 257.662171,327.845052 252.723078,378.822451 C250.578522,400.942531 255.516343,417.557192 252.906243,435.257824 C250.439876,451.993735 247.505421,468.756003 249.789895,484.427029 C257.162283,534.998507 287.81061,571.847734 312.967805,565.567375 Z",
    id: "Stroke-3",
    stroke: "url(#linearGradient-4)",
    transform: "translate(351.817143, 399.976489) rotate(-90.000000) translate(-351.817143, -399.976489) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.991058,584.837729 C378.039423,563.24133 362.938793,494.301821 387.224774,444.989162 C413.636303,391.360744 457.034456,374.18571 478.713254,341.143395 C491.605953,321.490143 490.787168,258.94859 465.427639,254.030876 C440.675228,249.23109 460.019347,211.091532 430.906841,200.187726 C416.254895,194.703261 405.054267,198.177694 393.792801,197.776392 C363.855173,196.704493 336.69964,182.475862 297.925215,223.216845 C273.161397,249.23813 245.708009,303.542426 243.07801,362.104399 C241.672386,393.442939 252.912305,412.649126 248.694167,434.277207 C244.51025,455.731039 238.780021,477.290476 242.858738,497.260545 C255.229239,557.851911 305.661848,598.726661 333.991058,584.837729 Z",
    id: "Stroke-5",
    stroke: "url(#linearGradient-5)",
    transform: "translate(364.185714, 391.032915) rotate(-90.000000) translate(-364.185714, -391.032915) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.24964,604.865318 C404.172904,572.154815 385.208427,491.303497 409.749642,437.49347 C436.796441,378.183044 481.87274,363.22751 509.453265,333.745503 C528.960385,312.89392 527.673837,227.678154 491.925645,226.883339 C456.501001,226.095558 488.80099,172.916812 447.923167,160.505741 C428.488655,154.606175 414.250012,161.740166 399.905642,161.098336 C368.148296,159.681033 340.221295,143.714397 298.695103,184.278093 C265.489435,216.717797 234.6021,280.733809 233.846731,346.694656 C233.384338,387.195049 250.783303,408.913543 244.950529,434.428509 C238.980184,460.537828 230.385791,486.870469 236.339577,511.070122 C253.686315,581.588846 324.526687,626.516991 356.24964,604.865318 Z",
    id: "Stroke-7",
    stroke: "url(#linearGradient-6)",
    transform: "translate(377.928571, 383.579937) rotate(-90.000000) translate(-377.928571, -383.579937) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.737861,624.142257 C430.306641,580.435888 407.502631,487.386342 432.151972,429.0197 C459.639891,363.929001 506.414119,352.060741 539.441845,325.220812 C565.729218,303.859353 563.749081,195.181917 517.769705,198.463017 C471.911147,201.735321 516.958319,133.287872 464.546359,119.463267 C440.434974,113.103386 423.24962,123.960046 405.906567,123.061042 C372.53165,121.329888 343.881338,103.279437 300.004189,144.012584 C258.407314,182.627529 224.603812,256.70299 225.547461,330.178528 C226.187159,379.884121 249.48207,404.15019 242.082944,433.593888 C234.344257,464.383453 222.922539,495.551269 230.745163,523.999201 C252.901845,604.584083 343.86862,653.695032 378.737861,624.142257 Z",
    id: "Stroke-9",
    stroke: "url(#linearGradient-7)",
    transform: "translate(390.984286, 375.133229) rotate(-90.000000) translate(-390.984286, -375.133229) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.848449,643.182153 C455.11584,588.722749 428.404601,483.702672 453.176968,420.986101 C481.088099,350.319419 529.533249,342.128926 568.028821,317.464456 C601.15345,296.240764 598.423537,163.931329 542.227976,171.255046 C485.984164,178.584028 543.716095,95.0438149 479.810754,79.910354 C451.032399,73.0937169 430.913581,87.6657044 410.582718,86.4936288 C375.5954,84.4793432 346.168215,64.2259475 300.000955,105.157353 C249.930554,149.550593 213.429723,233.652279 215.969176,314.4325 C217.815359,373.143309 246.871783,399.888741 237.91894,433.166563 C228.407418,468.523591 214.163625,504.436829 223.861797,537.019828 C250.776192,627.427562 361.888701,680.585049 399.848449,643.182153 Z",
    id: "Stroke-11",
    stroke: "url(#linearGradient-8)",
    transform: "translate(402.665714, 366.686520) rotate(-90.000000) translate(-402.665714, -366.686520) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.710794,663.367472 C482.73021,597.966915 452.051474,480.474758 476.963683,413.140782 C505.287881,336.58615 555.297416,332.373053 599.375593,309.43918 C639.30892,288.663707 635.856358,131.763185 569.452541,143.152784 C502.858535,154.575779 573.23096,55.547781 497.857835,39.0697723 C464.418824,31.7596883 441.37427,50.1306906 418.062184,48.6683222 C381.459698,46.3710681 351.231075,23.7131471 302.797572,65.125239 C244.173749,115.250023 205.125433,209.945404 209.200547,298.415173 C212.329789,366.360814 247.050672,395.717155 236.553514,432.977667 C225.263901,473.045154 208.200154,513.873705 219.785193,550.724684 C251.422481,651.367966 382.699729,708.811623 423.710794,663.367472 Z",
    id: "Stroke-13",
    stroke: "url(#linearGradient-9)",
    transform: "translate(417.095714, 358.239812) rotate(-90.000000) translate(-417.095714, -358.239812) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.272119,683.429387 C509.35838,607.107479 474.515371,477.150298 499.69086,405.229513 C528.545883,322.80129 580.23233,322.785452 630.232271,301.404548 C677.12375,281.352252 672.982526,99.6145693 596.043005,115.072171 C518.785516,130.596643 602.13147,16.065388 514.933007,-1.72739542 C476.669926,-9.53538475 450.591406,12.6532421 424.188558,10.886458 C385.800833,8.31723002 354.623367,-16.8172103 303.706404,25.1245562 C236.173669,80.7536205 194.513411,186.20811 200.107117,282.367625 C204.594291,359.520132 245.084424,391.494702 232.995254,432.732571 C219.870779,477.498728 199.903617,523.246823 213.43382,564.347431 C249.932811,675.220176 402.049034,736.92916 446.272119,683.429387 Z",
    id: "Stroke-15",
    stroke: "url(#linearGradient-10)",
    transform: "translate(430.151429, 349.793103) rotate(-90.000000) translate(-430.151429, -349.793103) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.116555,702.757536 C535.02184,615.68302 496.126165,473.520618 521.460936,397.170431 C550.705088,309.039306 603.737024,313.346618 659.556839,293.443319 C713.156511,274.331159 708.39997,67.9634325 621.249222,87.4588553 C533.660288,107.050973 629.62048,-22.7555965 530.971477,-41.8150139 C488.048302,-50.1061505 459.04674,-24.1304203 429.667957,-26.2084787 C389.663481,-29.0389982 357.679714,-56.6567813 304.504257,-14.221844 C228.282756,46.6026797 184.281262,162.761222 191.349393,266.432076 C197.224895,352.613483 243.261097,387.151095 229.634147,432.281179 C214.728203,481.651769 191.939991,532.228405 207.362868,577.490346 C248.558702,698.371109 420.897887,764.211454 468.116555,702.757536 Z",
    id: "Stroke-17",
    stroke: "url(#linearGradient-11)",
    transform: "translate(442.520000, 341.346395) rotate(-90.000000) translate(-442.520000, -341.346395) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.645112,723.66484 C561.395537,625.691905 518.328241,471.028911 543.925811,390.175068 C573.44966,296.127384 627.856865,304.906857 689.582554,286.369678 C749.83795,268.274111 744.542863,37.0326481 647.160969,60.3853422 C549.281789,84.2940109 657.810766,-61.2305903 547.721426,-81.5746874 C500.140494,-90.3682356 468.220281,-60.5514567 435.864943,-62.953056 C394.243837,-66.0443453 361.450836,-96.2341199 306.008464,-53.1971087 C221.048584,12.7527432 174.779372,139.96537 183.301747,251.341516 C190.597397,346.680609 242.083043,383.820067 226.976696,432.955205 C210.22626,486.970956 184.678165,542.50684 201.999466,591.999139 C247.88049,723.105347 440.447083,793.177504 490.645112,723.66484 Z",
    id: "Stroke-19",
    stroke: "url(#linearGradient-12)",
    transform: "translate(455.575714, 333.893417) rotate(-90.000000) translate(-455.575714, -333.893417) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.259386,742.675703 C588.156762,634.353739 540.793693,467.610881 566.576162,382.453009 C596.580813,282.903568 652.243527,296.073758 720.063736,278.916536 C787.042301,261.969897 781.201576,6.28569831 673.448371,33.7246186 C565.064251,61.5443425 686.414503,-99.0881087 564.666914,-120.427151 C512.347923,-129.785796 477.440668,-96.0697573 442.054832,-98.8564678 C398.731142,-102.122254 365.08064,-134.885406 307.262405,-91.3579703 C213.362676,-20.6688819 164.79744,117.289082 174.777832,236.001545 C183.534478,340.152218 240.618973,379.822481 223.924475,432.741903 C205.388009,491.266333 176.896539,551.549128 196.192135,605.065201 C246.714858,746.027477 460.108907,820.145553 513.259386,742.675703 Z",
    id: "Stroke-21",
    stroke: "url(#linearGradient-13)",
    transform: "translate(468.631429, 325.943574) rotate(-90.000000) translate(-468.631429, -325.943574) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.7163,618.506003 C245.123156,769.838657 478.899926,848.230122 535.207345,762.721114 C613.95898,643.128095 562.592591,463.914439 588.555227,374.043803 C619.039731,268.520552 675.897141,286.172833 749.86906,270.279272 C823.539945,254.450785 817.189007,-26.9445534 699.061554,4.71242209 C580.166907,36.575168 714.303806,-139.502689 580.934101,-162.36606 C523.859488,-172.149824 485.987573,-134.671482 447.564396,-137.743968 C402.550215,-141.344069 368.044297,-176.717222 307.843753,-132.467805 C204.958552,-56.8428081 154.151045,92.6484652 165.582734,219.276367 C175.824257,332.724415 238.483885,375.123658 220.200804,432.081592 C199.877801,495.395543 168.53465,560.651122 189.7163,618.506003 Z",
    id: "Stroke-23",
    stroke: "#F1F1F6",
    transform: "translate(481.000000, 317.000000) rotate(-90.000000) translate(-481.000000, -317.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave3);
export default __webpack_public_path__ + "static/media/wave_3.35d47241cada803bb9ed039a2f6a4a9a.svg";
export { ForwardRef as ReactComponent };